<template>
<div>
  <nav class="nav nav--sidebar" :class="{'nav--noAccess': noAccess, 'open':open }">

    <!-- Navigation Section-->
    <div class="nav__section">
      <!-- Navigation Section content -->
      <div class="topmenu nav__section__content">
        <div class="nav__disburse-trigger">
          <!-- navigation item -->
          <div class="nav__item">
            <!-- navigation item link -->
            <div class="nav__item__link nav__item__link--noHover no--padding" v-if="permitted">
              <router-link :to="{name:'single-disburse'}" class="btn btn--primary btn--block btn--disburse">Send Money</router-link>
            </div>
          </div>
        </div>
        <!-- navigation item -->
        <div class="page-navigation">
          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name:'overview'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                        <defs>
                            <path id="a" d="M2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM19 1a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H2v9h4c.379 0 .725.214.895.553L7.618 14h4.764l.723-1.447c.17-.339.516-.553.895-.553h4V3h-3a1 1 0 0 1 0-2h4zM6.293 6.707a.999.999 0 1 1 1.414-1.414L9 6.586V1a1 1 0 0 1 2 0v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3z"/>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                            <path fill="#F4F6F8" d="M1 13h5l1 2h6l1-2h5v6H1z"/>
                            <mask id="b" fill="#fff">
                                <use xlink:href="#a"/>
                            </mask>
                            <use fill="#919EAB" xlink:href="#a"/>
                            <g fill="#919EAB" mask="url(#b)">
                                <path d="M0 0h23v20H0z"/>
                            </g>
                        </g>
                    </svg>

                </span>
              <!-- navigation item link text -->
              <span class="nav__item__link__text">Overview</span>
            </router-link>
          </div>

          <!-- navigation item -->
          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name: 'approvals'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                      <defs>
                          <path id="approval-a" d="M19 0h-9c-.265 0-.52.106-.707.293l-9 9a.999.999 0 0 0 0 1.414l9 9a.997.997 0 0 0 1.414 0l9-9A.997.997 0 0 0 20 10V1a1 1 0 0 0-1-1zm-9 17.586L2.414 10 4 8.414 11.586 16 10 17.586zm8-8l-5 5L5.414 7l5-5H18v7.586zM15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#FFF" d="M4 7l-3 3 9 9 3-3z"/>
                          <mask id="approval-b" fill="#fff">
                              <use xlink:href="#approval-a"/>
                          </mask>
                          <use fill="#919EAB" xlink:href="#approval-a"/>
                          <g fill="#919EAB" mask="url(#approval-b)">
                              <path d="M0 0h23v20H0z"/>
                          </g>
                      </g>
                  </svg>

              </span>
              <!-- naviation item link text -->
              <span class="nav__item__link__text">Awaiting Approval</span>
            </router-link>
          </div>


          <!-- navigation item -->
          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name:'transfers'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                      <defs>
                          <path id="trans-a" d="M19.924 9.617a.997.997 0 0 1 0 .766l-.61 1.47v1.591c0 .265-.105.52-.293.707l-1.125 1.125-.608 1.47a.998.998 0 0 1-.541.542l-1.47.608-1.125 1.126a1.003 1.003 0 0 1-.707.293h-1.591l-1.471.609a.999.999 0 0 1-.765 0l-1.472-.609h-1.59c-.266 0-.52-.106-.708-.293l-1.125-1.126-1.47-.608a1.005 1.005 0 0 1-.542-.542l-.607-1.47-1.126-1.125a.997.997 0 0 1-.292-.707v-1.591l-.61-1.47a.997.997 0 0 1 0-.766l.61-1.47V6.556c0-.265.104-.52.292-.707l1.126-1.125.607-1.47c.103-.245.296-.44.542-.542l1.47-.608L5.848.978c.189-.187.442-.293.708-.293h1.59L9.617.076c.246-.101.52-.101.765 0l1.472.609h1.59c.265 0 .52.106.707.293l1.126 1.126 1.47.608c.245.102.44.297.54.542l.61 1.47 1.125 1.125c.187.187.293.442.293.707v1.591l.608 1.47zm-2.534 1.654L17.918 10l-.527-1.271a1.002 1.002 0 0 1-.076-.383V6.97l-.973-.973a.991.991 0 0 1-.216-.325l-.527-1.271-1.27-.526a.991.991 0 0 1-.325-.217l-.973-.973h-1.375c-.131 0-.262-.026-.383-.076l-1.273-.526-1.27.526c-.121.05-.252.076-.383.076H6.968l-.973.973a.987.987 0 0 1-.324.217l-1.27.526-.528 1.271a.988.988 0 0 1-.216.325l-.972.973v1.376c0 .132-.026.262-.076.383L2.082 10l.528 1.271c.05.121.076.251.076.383v1.376l.973.973a.988.988 0 0 1 .216.325l.527 1.271 1.27.526c.122.05.232.124.325.217l.973.973h1.375c.131 0 .262.026.383.076l1.271.526 1.272-.526c.121-.05.252-.076.383-.076h1.377l.971-.973a.991.991 0 0 1 .325-.217l1.271-.526.527-1.271a.991.991 0 0 1 .216-.325l.973-.973v-1.376c0-.132.026-.262.076-.383zm-5.097-4.978a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6-6zM7.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"/>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#FFF" d="M10 19l-1.654-.686h-1.79L5.29 17.049l-1.654-.685-.685-1.654-1.266-1.266v-1.79L1 10l.685-1.654v-1.79L2.95 5.29l.685-1.654 1.654-.685 1.266-1.265h1.79L10 1l1.654.686h1.79l1.266 1.265 1.654.685.685 1.654 1.266 1.266v1.79L19 10l-.685 1.654v1.79l-1.266 1.266-.685 1.654-1.654.685-1.266 1.265h-1.79z"/>
                          <mask id="trans-b" fill="#fff">
                              <use xlink:href="#trans-a"/>
                          </mask>
                          <use fill="#919EAB" xlink:href="#trans-a"/>
                          <g fill="#3C51DD" mask="url(#trans-b)">
                              <path d="M-26-26h23v20h-23z"/>
                          </g>
                      </g>
                  </svg>
              </span>
              <!-- naviation item link text -->
              <span class="nav__item__link__text">Transactions</span>
            </router-link>
          </div>

          <!-- navigation item -->
          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name:'wallet'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                      <defs>
                          <path id="wallet-a" d="M16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 6H4v-4a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v4zm-3.281 4H7.281c.357-.702.536-1.434.627-2h4.184c.091.566.27 1.298.627 2zM12 6c0 1.103-.897 2-2 2s-2-.897-2-2h4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm1.618-4h12.764l1 2H2.618l1-2zm16.277 2.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.474.811 2.75 2 3.444V15a1 1 0 0 0 1 1h2.871c-.157.747-.508 1.7-1.318 2.105a1.002 1.002 0 0 0-.527 1.125c.108.451.51.77.974.77h10c.464 0 .866-.319.974-.77a1.002 1.002 0 0 0-.527-1.125c-.801-.4-1.153-1.356-1.313-2.105H17a1 1 0 0 0 1-1V9.444c1.189-.694 2-1.97 2-3.444V5c0-.155-.036-.309-.105-.447z"/>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#FFF" d="M19 6a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0V5l2-4h14l2 4v1z"/>
                          <mask id="wallet-b" fill="#fff">
                              <use xlink:href="#wallet-a"/>
                          </mask>
                          <use fill="#919EAB" xlink:href="#wallet-a"/>
                          <g fill="#919EAB" mask="url(#wallet-b)">
                              <path d="M0 0h23v20H0z"/>
                          </g>
                      </g>
                  </svg>
              </span>
              <!-- naviation item link text -->
              <span class="nav__item__link__text">Balance</span>
            </router-link>
          </div>
          <!-- navigation item -->
          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name:'beneficiaries'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="20" viewBox="0 0 16 20">
                        <defs>
                            <path id="bene-a" d="M17.707 15.293a.999.999 0 0 1 .241 1.023l-1 3A.999.999 0 0 1 16 20H4a1 1 0 0 1-.949-.684l-1-3a.999.999 0 0 1 .242-1.023C2.427 15.158 5.635 12 10 12c4.364 0 7.572 3.158 7.707 3.293zM15.28 18l.562-1.687c-.92-.752-3.155-2.313-5.84-2.313-2.704 0-4.928 1.558-5.844 2.31L4.72 18h10.56zM10 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 8c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5"/>
                        </defs>
                        <g fill="none" fill-rule="evenodd" transform="translate(-2)">
                            <path fill="#FFF" d="M10 13c-4 0-7 3-7 3l1 3h12l1-3s-3-3-7-3"/>
                            <mask id="bene-b" fill="#fff">
                                <use xlink:href="#bene-a"/>
                            </mask>
                            <use fill="#919EAB" xlink:href="#bene-a"/>
                            <g fill="#919EAB" mask="url(#bene-b)">
                                <path d="M0 0h23v20H0z"/>
                            </g>
                        </g>
                  </svg>
              </span>
              <!-- naviation item link text -->
              <span class="nav__item__link__text">Beneficiaries</span>
            </router-link>
          </div>


          <!-- navigation item -->
          <div class="nav__item" v-if="posMerchant">
            <!-- <!- navigation item link -- -->
            <router-link :to="{name:'pos'}" class="nav__item__link nav__item__link--flex">
              <!-- <!- navigation item link icon -- -->
              <span class="nav__item__link__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                      <defs>
                          <path id="trans-a" d="M19.924 9.617a.997.997 0 0 1 0 .766l-.61 1.47v1.591c0 .265-.105.52-.293.707l-1.125 1.125-.608 1.47a.998.998 0 0 1-.541.542l-1.47.608-1.125 1.126a1.003 1.003 0 0 1-.707.293h-1.591l-1.471.609a.999.999 0 0 1-.765 0l-1.472-.609h-1.59c-.266 0-.52-.106-.708-.293l-1.125-1.126-1.47-.608a1.005 1.005 0 0 1-.542-.542l-.607-1.47-1.126-1.125a.997.997 0 0 1-.292-.707v-1.591l-.61-1.47a.997.997 0 0 1 0-.766l.61-1.47V6.556c0-.265.104-.52.292-.707l1.126-1.125.607-1.47c.103-.245.296-.44.542-.542l1.47-.608L5.848.978c.189-.187.442-.293.708-.293h1.59L9.617.076c.246-.101.52-.101.765 0l1.472.609h1.59c.265 0 .52.106.707.293l1.126 1.126 1.47.608c.245.102.44.297.54.542l.61 1.47 1.125 1.125c.187.187.293.442.293.707v1.591l.608 1.47zm-2.534 1.654L17.918 10l-.527-1.271a1.002 1.002 0 0 1-.076-.383V6.97l-.973-.973a.991.991 0 0 1-.216-.325l-.527-1.271-1.27-.526a.991.991 0 0 1-.325-.217l-.973-.973h-1.375c-.131 0-.262-.026-.383-.076l-1.273-.526-1.27.526c-.121.05-.252.076-.383.076H6.968l-.973.973a.987.987 0 0 1-.324.217l-1.27.526-.528 1.271a.988.988 0 0 1-.216.325l-.972.973v1.376c0 .132-.026.262-.076.383L2.082 10l.528 1.271c.05.121.076.251.076.383v1.376l.973.973a.988.988 0 0 1 .216.325l.527 1.271 1.27.526c.122.05.232.124.325.217l.973.973h1.375c.131 0 .262.026.383.076l1.271.526 1.272-.526c.121-.05.252-.076.383-.076h1.377l.971-.973a.991.991 0 0 1 .325-.217l1.271-.526.527-1.271a.991.991 0 0 1 .216-.325l.973-.973v-1.376c0-.132.026-.262.076-.383zm-5.097-4.978a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6-6zM7.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"/>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#FFF" d="M10 19l-1.654-.686h-1.79L5.29 17.049l-1.654-.685-.685-1.654-1.266-1.266v-1.79L1 10l.685-1.654v-1.79L2.95 5.29l.685-1.654 1.654-.685 1.266-1.265h1.79L10 1l1.654.686h1.79l1.266 1.265 1.654.685.685 1.654 1.266 1.266v1.79L19 10l-.685 1.654v1.79l-1.266 1.266-.685 1.654-1.654.685-1.266 1.265h-1.79z"/>
                          <mask id="trans-b" fill="#fff">
                              <use xlink:href="#trans-a"/>
                          </mask>
                          <use fill="#919EAB" xlink:href="#trans-a"/>
                          <g fill="#3C51DD" mask="url(#trans-b)">
                              <path d="M-26-26h23v20h-23z"/>
                          </g>
                      </g>
                  </svg>
              </span>
              <!-- <!- naviation item link text -- -->
              <span class="nav__item__link__text">POS</span>
            </router-link>
          </div>


          <div class="nav__item">
            <!-- navigation item link -->
            <router-link :to="{name: 'team-settings'}" class="nav__item__link nav__item__link--flex">
              <!-- navigation item link icon -->
              <span class="nav__item__link__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                      <defs>
                          <path id="approval-a" d="M19 0h-9c-.265 0-.52.106-.707.293l-9 9a.999.999 0 0 0 0 1.414l9 9a.997.997 0 0 0 1.414 0l9-9A.997.997 0 0 0 20 10V1a1 1 0 0 0-1-1zm-9 17.586L2.414 10 4 8.414 11.586 16 10 17.586zm8-8l-5 5L5.414 7l5-5H18v7.586zM15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                          <path fill="#FFF" d="M4 7l-3 3 9 9 3-3z"/>
                          <mask id="approval-b" fill="#fff">
                              <use xlink:href="#approval-a"/>
                          </mask>
                          <use fill="#919EAB" xlink:href="#approval-a"/>
                          <g fill="#919EAB" mask="url(#approval-b)">
                              <path d="M0 0h23v20H0z"/>
                          </g>
                      </g>
                  </svg>

              </span>
              <!-- naviation item link text -->
              <span class="nav__item__link__text">Settings</span>
            </router-link>
          </div>

          <div class="nav__item" style="padding-left: 35px; padding-top: 5px;">
            <!-- navigation item link -->
            <toggle-button 
              v-model="myDataVariable"
              :sync="true"
              @change="onChangeEventHandler"
              :labels="{checked: 'ON', unchecked: 'OFF'}"
              :color="{checked: '#FF0000', unchecked: '#82C7EB'}"
              :font-size="10"
              :width="50"
              :height="20"
              style="margin: 0 0px 0 0px; z-index: 0"
            />
            <span style="padding-left: 7px;" class="nav__item__link__text">Test Mode</span>
          </div>

        </div>
      </div>
    </div>

    <!-- Navigation Section -->
    <div class="nav__section">
      <!-- Navigation Section content -->
      <div class="nav__section__content">
        <!-- navigation item -->
        <div class="nav__item">
          <!-- navigation item link -->
          <div class="nav__item__link nav__item__link--flex nav__item__link--noHover">
            <!-- navigation item link icon -->
            <div class="company" :class="{'company--open': companyOpen}">
              <transition name="slide-fade">
                <div class="company__list" v-if="companyOpen">
                   <div class="company__list__item"  v-for="(merchants, index) in merchantList" @click="changeState(index)">
                    <div class="company__list__item__link company__list__item__link--flex">
                      <div class="company__list__item__link__text">{{merchants.name}}</div>
                    </div>
                   </div>
                   <!-- <div class="company__list__item">
                    <div class="company__list__item__link company__list__item__link--flex">
                      <div class="company__list__item__link__text">Rebate</div>
                    </div>
                  </div> -->
                   <!-- <div data-toggle="modal" data-target="#createAccountModal" class="company__list__item">
                    <div class="company__list__item__link company__list__item__link&#45;&#45;flex">
                      <div class="company__list__item__link__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9" height="9" viewBox="0 0 12 12"><defs><path id="plusguy" d="M12 6.857H6.857V12H5.143V6.857H0V5.143h5.143V0h1.714v5.143H12z"></path> <filter id="kind" width="133.3%" height="133.3%" x="-16.7%" y="-16.7%" filterUnits="objectBoundingBox"><feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5"></feGaussianBlur> <feOffset dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset> <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1"></feComposite> <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0.719972364 0 0 0 0 0.70511498 0 0 0 0 0.70511498 0 0 0 1 0"></feColorMatrix></filter></defs> <g fill="none" fill-rule="nonzero"><use fill="#FFF" stroke="none" fill-rule="evenodd" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#plusguy"></use> <use fill="#000" stroke="none" filter="url(#kind)" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#plusguy"></use></g></svg>
                      </div>
                      <div class="company__list__item__link__text">Edit business</div>
                    </div>
                  </div> -->
                </div>
              </transition>

              <div class="company__row" @click="companyOpenInitialControl()" v-click-outside="companyOpenControl">
                <div class="company__content">
                  <div class="company__name">{{getBusinessName}}</div>
                  <div class="company__position">Company Administrator</div>
                </div>
                <div class="company__toggle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                    <path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div
    class="modal fade"
    id="createAccountModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createAccountModal"
  >
    <!-- Modal Dialog -->
    <div class="modal__dialog modal__dialog--lg" role="document">
      <!-- Modal content -->
      <div class="modal__content">
        <div class="modal__header">
          <div class="modal__title">
            <span class="time-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                width="512px"
                height="512px"
                viewBox="0 0 612 612"
                style="enable-background:new 0 0 612 612;"
                xml:space="preserve"
                class="icon--sm"
              >
                <g>
                  <g>
                    <g>
                      <path
                        d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#576ae6"
                        fill="#576ae6"
                      ></path>
                      <path
                        d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#576ae6"
                        fill="#576ae6"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            Link a User
          </div>
          <!-- Modal close button -->
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="utilityMethods().triggerRefresh()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
              <path
                fill="#C0C6D8"
                fill-rule="nonzero"
                d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
              ></path>
            </svg>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="modal__body modal__body--pad">
          <div class>
            <form
              action
              class="form disburse-form"
              @submit.prevent="validateUser()"
            >
              <div class="form__item">
                <label for="beneficiarySource" class="form__label--span form--left">
                  User
                  <span>Email</span>
                </label>
                <div class="select form--right">
                  <input
                    type="email"
                    v-model="createObject.email"
                    id="authLoginEmail"
                    autocomplete="new-password"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
              </div>
              <div class="form__item">
                <label for="beneficiarySource" class="form__label--span form--left">
                  <span>Password</span>
                </label>
                <div class="select form--right">
                  <input
                    type="password"
                    autocomplete="new-password"
                    v-model="createObject.password"
                    id="authLoginPassword"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
              </div>
              <div v-if="errormessage" style="color: red;">
                  {{errormessage}}
              </div>
              <br>
              <div class="form__item">
                <button
                  v-if="enableActions"
                  id="linkBtn"
                  type="submit"
                  class="btn btn--primary btn--block"
                >Validate User</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
      class="modal fade"
      id="confirmLinkModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmLinkModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">Linking
              <span>Confirmation</span>
            </div>
            <!-- Modal close button -->
            <button
              type="button"
              class="close btn btn--default btn--sm"
              data-dismiss="modal"
              aria-label="Close"
              @click="utilityMethods().triggerRefresh()"
              ref="closeModal"
            >
              <span>Close</span>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <form
              class="disburse__confirmation"
              @submit.prevent="handleLinkingUsers()"
              v-if="!linkUserFinished && userToLink.merchants"
            >
              <div class="disburse__confirmation__title text-center"> You are about to link the account below </div>

              <div class="disburse__confirmation__breakdown">
                <div class="breakdown__item">
                  <div class="breakdown__item__name">User</div>
                  <div class="breakdown__item__result">{{fullName}}</div>
                </div>
              </div>

              <br>

              <div class="disburse__confirmation__breakdown">
                <div class="breakdown__item" v-for="merchants in userToLink.merchants">
                  <div class="breakdown__item__name">Merchant Name</div>
                  <div class="breakdown__item__result">{{merchants.name}}</div>
                </div>
              </div>


              <!--confirm disbursement-->
              <div class="disburse__confirmation__submit">
                <button
                  class="btn btn--primary btn--block submit__paymentForm"
                  type="submit"
                >CONFIRM LINK</button>
              </div>
            </form>

            <div class="disburse__result text-center" v-if="linkUserFinished">
              <div v-if="linkSuccessful">
                <!--success icon-->
                <div class="result-img">
                  <svg
                    class="icon icon--custom-big"
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                      points="38 15 22 33 12 25"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">Merchants successfully linked</p>
                <button
                  class="btn btn--primary"
                  @click="utilityMethods().triggerPageLoad()"
                >Link another User</button>
                <button
                  class="btn btn--default"
                  @click="utilityMethods().triggerRefresh()"
                >Close</button>
              </div>

              <div v-if="linkFailed">
                <div class="result-img">
                  <svg
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                      points="16 34 25 25 34 16"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                    <polyline
                      points="16 16 25 25 34 34"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p
                  v-for="error in linkErrors"
                  class="disburse__result__error error-text"
                >{{error}}</p>
                <button
                  class="btn btn--primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="utilityMethods().triggerPageLoad2()"
                >Retry linking</button>
                <button
                  class="btn btn--default"
                  @click="utilityMethods().triggerRefresh()"
                >Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</template>


<script>
  import { resolveAccountName } from '../../utils/helpers/utilitiesService';
  import {login} from '../../utils/auth/authService'
  import {getUser, linkUserToUser, updateMerchantScope} from '../../utils/user/getUserDetails'
  import appConfig from '@/config';

  const STAGING_PASSWORD = appConfig.api.staginPassword;
  let baseUrl = appConfig.api.orinalBase;



  export default {

    created:function(){
      for(let i = 0; i<this.$route.matched.length; i++){
        if(this.$route.matched[0].path === '/signup'){
          this.noAccess = true;
        }
        // console.log(this.$route.matched[0].path);
      }
      
    },
    props: ['open'],

    data() {
      return {
        disabled: false,
        password: '',
        createObject: {
          email: '',
          password: '',
        },
        errormessage: null,
        fullName: (this.$cookies.get('userLastName') !== '' && this.$cookies.get('userLastName') !== null) ? `${this.$cookies.get('userFirstName')} ${this.$cookies.get('userLastName')}` : this.$cookies.get('userFirstName'),
        userToLink: {},
        dropdownOpen:true,
        noAccess:false,
        companyOpen: false,
        pageNotSignUp: false,
        linkUserFinished: false,
        linkSuccessful: false,
        linkFailed: false,
        linkErrors: [],
        posMerchant: JSON.parse(window.localStorage.getItem('posMerchant')) || false,
        merchantList: JSON.parse(window.localStorage.getItem('List')),
        myDataVariable: this.change(),
      }
    },

    computed: {
        enableActions: {
          get() {
            return this.$store.state.enableActions;
          },
        },
        getBusinessName() {
            if(this.$store.state.authUser.businessName === ''){
                return window.localStorage.getItem('merchantName');
            }
            else{
                return this.$store.state.authUser.businessName;
            }


        },
        permitted() {
          let permission = window.localStorage.getItem('permissions');
          permission = (permission) ? JSON.parse(window.localStorage.getItem('permissions')) : [];
          console.log('perm ', !!(permission.includes('wallet.disburse')))
          return !!(permission.includes('wallet.disburse'));
        }
    },

    methods:{
      change() {
        if (window.localStorage.getItem('staging') === 'true') return true;
        else return false;
      },
      onChangeEventHandler() {
        window.localStorage.setItem('staging', this.myDataVariable);
        if (this.myDataVariable == true) {
          login(this.$cookies.get('userEmail'), STAGING_PASSWORD, true)
          .then((response) => {
            let token = response.data.token_type + ' ' + response.data.access_token;
            this.$cookies.set('stagingToken', token);
            this.$cookies.set('token', token);
            this.getUserDetails();
          })
          .catch((error) => {
            console.log(error);
          });
        } else if (this.myDataVariable == false) {
          this.$cookies.set('token', this.$cookie.get('productionToken'));
          this.getUserDetails(baseUrl);
        }
      },
      getUserDetails(url = false){
        //after login is successful, get user details.
        getUser(url)
          .then(responseUser =>{
            this.$Progress.start();
            //cache user details if getuser api call is successful
            if(responseUser.status === 200){              
              console.log(responseUser);
              this.$store.commit('updateMerchantList', responseUser.data.merchants);
              this.$store.commit('updateUserFirstName', responseUser.data.name)
              this.$store.commit('updateUserPhonenumber', responseUser.data.phonenumber)
              this.$store.commit('updateUserEmail', responseUser.data.email)
              this.$store.commit('updateUserBusinessName', responseUser.data.merchants[0].name)
              this.$store.commit('updateUserAccountNumber', responseUser.data.merchants[0].account);
              this.$store.commit('updateCompliance', responseUser.data.merchants[0].compliance);
              this.$store.commit('updateUserMerchantId', responseUser.data.merchants[0].id);
              this.$store.commit('updateUserMerchantPosState', responseUser.data.merchants[0].posMerchant || false);
              let permissions = responseUser.data.merchants[0].permission || [];
              // to be removed later
              if (JSON.parse(window.localStorage.getItem('staging')) === true && permissions.length === 0) permissions = ["wallet.disburse", "wallet.list"];
              this.$store.commit('updateUserPermissions', permissions);
              this.$router.push('/overview'); location.reload();
            }
          })
        .catch(error =>{
            this.$Progress.fail()
            console.log(this.errors);
        })
      },
      validateUser() {
        this.errormessage = null;
        const email = this.createObject.email;
        const password = this.createObject.password;
        if (email !== '' && password !== '') {
          document.getElementById('linkBtn').disabled = true;
          this.$Progress.start();
          login(email, password)
          .then((resp) => {
            let nextResp = false;
            if (resp.status === 200) {
              let token = resp.data.token_type + ' ' + resp.data.access_token;
              nextResp = getUser(false, token);
            }
            return nextResp;
          })
          .then((response) => {
            this.$Progress.finish();
            if (response.data.merchants) {
              this.userToLink = response.data;
              $("#createAccountModal").modal("hide");
              $("#confirmLinkModal").modal("show");
            }
          })
          .catch((err) => {
            this.$Progress.fail();
            console.log(err.response);
            if (err.response.data.error_description === 'Invalid resource owner credentials') this.errormessage = 'Invalid Credentials';
            else this.errormessage = err.response.data.error_description || err.response.data.msg;
            document.getElementById('linkBtn').disabled = false;
          })
        } else {
          this.errormessage = 'Please fill all fields';
        }
      },

      handleLinkingUsers() {
        this.$Progress.start();
        const baseEmail = this.$cookies.get('userEmail');
        const targetEmail = this.userToLink.email;
        linkUserToUser(baseEmail, targetEmail)
        .then((resp) => {
          if (resp.status === 200 && resp.data.data) {
            if (resp.data.data.length < 1) throw ({ response: { data: { message: 'All merchants linked already' } } });
            this.$Progress.finish();
            this.linkUserFinished = true;
            this.linkSuccessful = true;
            this.linkFailed = false;
            for (let x=0; x < resp.data.data.length; x++) {
              const currentSuccessfulMerchantId = resp.data.data[x].merchant_id;
              for (let y=0; y<this.userToLink.merchants.length; y++) {
               const currentSentMerchant = this.userToLink.merchants[y];
                if (currentSentMerchant.id === currentSuccessfulMerchantId) this.merchantList.push(currentSentMerchant);
              }
            }
            this.$store.commit('updateMerchantList', this.merchantList);
          } else {
            this.$Progress.fail();
            this.linkUserFinished = true;
            this.linkSuccessful = false;
            this.linkErrors.push('Error, merchants could not be linked');
            this.linkFailed = true;
          }
        })
        .catch((err) => {
          this.$Progress.fail();
          this.linkUserFinished = true;
          this.linkSuccessful = false;
          this.linkFailed = true;
          this.linkErrors.push(err.message || err.response.data.message || err.response.data.msg);
        });
      },

      companyOpenInitialControl(){
        this.companyOpen = true;
        this.noAccess = true;
        for(let i = 0; i<this.$route.matched.length; i++){
          if(this.$route.matched[0].path === '/signup'){
            this.companyOpen = !this.companyOpen;
            this.noAccess = !this.noAccess;

          }
        }

      },

      changeState(nkey) {
      
        this.$store.commit('updateCompliance', this.merchantList[nkey].compliance);
        this.$store.commit('updateUserBusinessName', this.merchantList[nkey].name);
        this.$store.commit('updateUserMerchantId', this.merchantList[nkey].id);
        this.$store.commit('updateUserMerchantPosState', this.merchantList[nkey].posMerchant);
        this.$store.commit('updateUserAccountNumber', this.merchantList[nkey].account);
        let permissions = this.merchantList[nkey].permission || [];
        if (JSON.parse(window.localStorage.getItem('staging')) === true && permissions.length === 0) permissions = ["wallet.disburse", "wallet.list"];
        this.$store.commit('updateUserPermissions', permissions);

        updateMerchantScope(this.merchantList[nkey].id, this.$cookies.get('userEmail'))
        .then((resp) => {
          this.$router.push('/overview');
          location.reload();
        })
        .catch((err) => {
          this.$router.push('/overview');
          location.reload();
        });
        // self.$router.go();
        // this.$forceUpdate();
        // location.reload();
      },

      //control use of the clickout directive for the companyOpen overlay
      companyOpenControl(){
         this.companyOpen = false;
         this.noAccess = false
        for(let i = 0; i<this.$route.matched.length; i++) {
          if (this.$route.matched[0].path === '/signup') {
            this.noAccess = true;
          }
        }
      },
      utilityMethods() {
        let triggerRefresh = () => {
          this.createObject = {
            email: '',
            password: '',
          };
          this.type = '';
          this.errormessage = null;
          this.linkUserFinished = false;
          this.linkSuccessful = false;
          this.linkFailed = false;
          this.linkErrors = [];
          this.userToLink = {};
          document.getElementById('linkBtn').disabled = false;
          $("#confirmLinkModal").modal("hide");
        };
        let triggerPageLoad = () => {
          this.createObject = {
            email: '',
            password: '',
          };
          this.errormessage = null;
          this.linkUserFinished = false;
          this.linkSuccessful = false;
          this.linkFailed = false;
          this.linkErrors = [];
          this.userToLink = {};
          document.getElementById('linkBtn').disabled = false;
          $("#createAccountModal").modal("show");
          $("#confirmLinkModal").modal("hide");
        };
        let triggerPageLoad2 = () => {
          this.errormessage = null;
          this.linkUserFinished = false;
          this.linkSuccessful = false;
          this.linkFailed = false;
          this.linkErrors = [];
          this.userToLink = {};
          $("#createAccountModal").modal("show");
          document.getElementById('linkBtn').disabled = false;
        }
        return {triggerRefresh,triggerPageLoad,triggerPageLoad2}
      }
    }




  }
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/SidebarView.vue